import React from 'react';
import { observer } from 'mobx-react';

function InfoPanelTemplate({ messages }) {
	return (
		<div className="react-info-panel">
			<span className="spc--right--sml">
				<i className="spc--left--tny fas fa-exclamation-circle" />
			</span>
			<div>
				{messages.map((msg, index) => (
					<div key={index}>{msg}</div>
				))}
			</div>
		</div>
	);
}

export default observer(InfoPanelTemplate);
